module.exports = __webpack_public_path__ + "img/comm-tst-mob.f91e38af.svg";